module.exports = __webpack_public_path__ + "img/place.577f8722.svg";